import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import TermAndConditions, { PostTermAndCondition } from '../../redux/actions/TermAndConditions'
import RefreshToken from '../../redux/actions/RefreshToken';
import CheckBox from '../../components/atoms/CheckBox';
import Button from '../../components/atoms/Button';

class ModalTermCondition extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalShow : false,
            loadingButton : false,
            checklist : {}
        }
    }
    
    componentDidMount = () => {
        this.getTermConditions();
    }
    
    getTermConditions = () => {
        const {RefreshToken, CheckTnC} = this.props;
        
        RefreshToken(ClientID => {
            CheckTnC(ClientID, res => {
                this.setState({ modalShow : res });
            });
        })
    }


    componentDidUpdate = (prevProps) =>{
        const {TnCState} = this.props;
        if(prevProps.TnCState !== TnCState){
            if(TnCState){
                let data_item = {};
                TnCState.items.map((data) => {
                    data_item[data.itemID] = false
                })

                this.setState({
                    checklist : {...data_item}
                })
            } 
        }
    }

    changeChecklist = ({name}) => {
        this.setState({
            checklist : {
                ...this.state.checklist,
                [name] : !this.state.checklist[name]
            }
        })
    }

    submitAgreement = () => {
        const {RefreshToken, PostTnC, TnCState} = this.props;
        const {checklist} = this.state;
        
        let data = [];
        for (const key of Object.keys(checklist)) {
            const dataPush = { "itemID": Number(key), "agreementFlag": checklist[key] }
            data.push(dataPush);
        }

        this.setState({loadingButton : true});
        RefreshToken(ClientID => {
            PostTnC(ClientID, TnCState.tncCode, data, res => {
                this.setState({ loadingButton : false });
                if(res){
                    this.getTermConditions();
                }
            })
        })
    }
    
    render() {
        const {modalShow, checklist, loadingButton} = this.state;
        const {TnCState} = this.props;

        return (
            <div className={`kc-modal ${!modalShow && 'kc-modal-hiden'}`}>
                <div className='kc-modal-dialog'>
                    <button type="button" className="kc-modal-close" onClick={() => {this.setState({modalShow : false})}}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                    
                    <div className='kc-modal-content'>
                        <h1>Syarat dan Ketentuan</h1>
                        {
                            TnCState ?
                            <Fragment>
                                <div className='container full-width text-left'>
                                    <div className='documentRender' dangerouslySetInnerHTML={{ __html: TnCState.content  }} />

                                    {TnCState.items.map((data, index) => (
                                        <CheckBox onChange={e => this.changeChecklist(e)} 
                                            key={index} className='mb-2' name={data.itemID} 
                                            data={[{text : data.content, value : checklist[data.itemID], checked : checklist[data.itemID]}]} />
                                    ))}
                                </div>
                                    
                                <Button className='mt-5' onClick={this.submitAgreement} type='button' title='KIRIM' loading = {loadingButton} isDisabled={!Object.values(checklist).every(data => data === true)} color="blue" width="big-rounded"/>
                            </Fragment>
                            : <div className="spinner-border text-secondary mt-3 loader" role="status" />
                        }
                        


                        <div className='kc-modal-button'>
                        
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
	return {
        TnCState : state.tnc.list
	}
}

const mapDispatchToProps = dispatch => {
	return {
        RefreshToken : ( cb, isPageLoading ) => {
            dispatch(RefreshToken( cb, isPageLoading ))
        },
		CheckTnC : (ClientID, cb) => {
			dispatch(TermAndConditions(ClientID, cb))
        },
        PostTnC : (ClientID, tncCode, data, cb) => {
            dispatch(PostTermAndCondition(ClientID, tncCode, data, cb))
        }
	}
}
export default connect(mapStateToProps, mapDispatchToProps)(ModalTermCondition);